import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=3d1d66ef&"
import script from "./Sticky.vue?vue&type=script&lang=js&"
export * from "./Sticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports